<template>
    <a
      :href="whatsappLink"
      target="_blank"
      rel="noopener noreferrer"
      class="whatsapp-float"
    >
      <img src="https://cdn-icons-png.flaticon.com/512/733/733585.png" alt="WhatsApp" />
    </a>
  </template>

  <script>
  import { getWhatsAppLink } from '@/Services/api/PagesService';

  export default {
    name: "WhatsAppFloat",
    props: {
      phone: {
        type: String,
        required: true
      },
      message: {
        type: String,
        default: "Hello!"
      }
    },
    data() {
      return {
        backendLink: null
      };
    },
    computed: {
      whatsappLink() {
        if (this.backendLink) {
          if(!this.backendLink.startsWith('http')){
            this.backendLink = 'https://' + this.backendLink;
          }
          return this.backendLink;
        }
        return `https://wa.me/${this.phone}}`;
      }
    },
    async mounted() {
      try {
        const response = await getWhatsAppLink();
        if (response && response.data) {
          this.backendLink = response.data;
        }
      } catch (error) {
        console.error("Failed to fetch WhatsApp link from backend:", error);
      }
    }
  };
  </script>

  <style scoped>
  .whatsapp-float {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 20px;
    left: 20px;
    z-index: 1000;
    cursor: pointer;
  }

  .whatsapp-float img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    box-shadow: 0 4px 10px rgba(0,0,0,0.3);
    transition: transform 0.3s ease;
  }

  .whatsapp-float img:hover {
    transform: scale(1.1);
  }
  </style>